import { Card, CardContent, Typography, CardActionArea, useTheme } from '@mui/material';

interface CustomCardProps {
    title: string;
    content: string;
    onClick: () => void;
    color?: "primary" | "secondary" | "success" | "error" | "warning" | "default";
}

const CustomCard: React.FC<CustomCardProps> = ({ title, content, onClick, color = "primary" }) => {
    const theme = useTheme();
    return (
        <Card
            sx={{
                minWidth: { xs: '7rem', sm: '9rem', md: '11rem' },
                m: { xs: 0.5, md: 1 },
                backgroundColor: color === 'default' ? theme.palette.grey[600] : theme.palette[color].main,
            }}
        >
            <CardActionArea
                onClick={onClick}
                sx={{ height: '100%', "&:focus": { outline: "none", boxShadow: "none" } }}
            >
                <CardContent
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        py: { xs: 1, md: 1.5 },
                        '&:last-child': { pb: { xs: 1, md: 1.5 } },
                    }}
                >
                    <Typography variant="h4" sx={{ color: 'white', lineHeight: 1 }}>
                        {title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'white' }}>
                        {content}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default CustomCard;